import { FaceFrownIcon } from "@heroicons/react/24/outline";
import { Text } from "north.js";
import React from "react";
import styled from "styled-components";

import { Container, PhotoFrame, TextStack } from "../styles";

const StyledFaceFrownIcon = styled(FaceFrownIcon)`
  width: 50%;
  height: 50%;
  color: ${({ theme }) => theme.globalConstants.color.borderGray};
`;

const Title = styled(Text)`
  color: ${({ theme }) => theme.globalConstants.color.black};
  font-weight: 700;
`;

const Message = styled(Text)`
  color: ${({ theme }) => theme.globalConstants.color.textSecondary};
`;

const ErrorProfileCell: React.FC = () => (
  <Container>
    <PhotoFrame>
      <StyledFaceFrownIcon />
    </PhotoFrame>

    <TextStack>
      <Title type="body1">Profile unavailable</Title>
      <Message type="body1">
        We couldn&apos;t load this hacker&apos;s profile.
      </Message>
    </TextStack>
  </Container>
);

export default ErrorProfileCell;
